export default [
    {
        "_id": "65d5d1e25d3d2640b99654a3",
        "provider": "dsas",
        "name": "Natation",
        "disciplines": [
            {
                "_id": "65d5d1e25d3d2640b99654a4",
                "name": "Natation nage libre",
                "epreuves": [
                    {
                        "_id": "65d5d1e35d3d2640b99654a6",
                        "name": "100m Papillon",
                        "categories": [
                            {
                                "_id": "65d5d1e35d3d2640b99654a5",
                                "type": "Sexe",
                                "name": "Femmes"
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "_id": "65d5d1e35d3d2640b99654a7",
        "provider": "dsas",
        "name": "Athlétisme",
        "disciplines": [
            {
                "_id": "65d5d1e35d3d2640b99654a8",
                "name": "Course de 100 mètres",
                "epreuves": [
                    {
                        "_id": "65d5d1e35d3d2640b99654aa",
                        "name": "100 mètres hommes",
                        "categories": []
                    }
                ]
            }
        ]
    },
    {
        "_id": "65d5d1e35d3d2640b99654ad",
        "provider": "dsas",
        "name": "Judo",
        "disciplines": [
            {
                "_id": "65d5d1e35d3d2640b99654ae",
                "name": "Judo masculin",
                "epreuves": [
                    {
                        "_id": "65d5d1e35d3d2640b99654af",
                        "name": "Judo masculin 65d5d1e35d3d2640b99654ab",
                        "categories": []
                    },
                    {
                        "_id": "65d5d1e35d3d2640b99654b0",
                        "name": "Judo masculin 65d5d1e35d3d2640b99654ac",
                        "categories": []
                    }
                ]
            },
            {
                "_id": "65d5d1e35d3d2640b99654b3",
                "name": "Judo féminin",
                "epreuves": [
                    {
                        "_id": "65d5d1e35d3d2640b99654b4",
                        "name": "Judo féminin 65d5d1e35d3d2640b99654b1",
                        "categories": [
                            {
                                "_id": "65d5d1e35d3d2640b99654a5",
                                "type": "Sexe",
                                "name": "Femmes"
                            }
                        ]
                    },
                    {
                        "_id": "65d5d1e35d3d2640b99654b5",
                        "name": "Judo féminin 65d5d1e35d3d2640b99654b2",
                        "categories": [
                            {
                                "_id": "65d5d1e35d3d2640b99654a5",
                                "type": "Sexe",
                                "name": "Femmes"
                            }
                        ]
                    }
                ]
            }
        ]
    }
]